import React from 'react';
import AuthPageTemplate from './template/auth-page';
import EditProfileChangePwdPanel from './../ui/panel/edit-profile/change-pwd';
import ProfileMenu from './../ui/menu/profile';

const ProfileUpdatePwdPage = () => {
    return (
        <AuthPageTemplate childMenu={
            <div>
                <ProfileMenu />
            </div>
        }>
            <EditProfileChangePwdPanel />
        </AuthPageTemplate>
    );
};

export default ProfileUpdatePwdPage;
